@use '~styles/variables' as *;

:global(#signup-app) {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.tos {
  font-size: 13px;
  margin: 6px 0 8px;
  font-weight: 700;
  text-align: center;

  a {
    color: #00d68c;
    text-decoration: none;
  }
}
